import { Injectable, inject } from '@angular/core';
import { SessionService } from '@yukawa/chain-main-angular-session';
import { TranslocoService } from '@jsverse/transloco';
import { catchError, lastValueFrom, of } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class AppInitializerService {
  private _sessionService = inject(SessionService);
  private _translocoService = inject(TranslocoService);


  async initialize(): Promise<void> {
    // Merge translations first
    await this.mergeTranslations((lang: string) => `yukawa/${lang}`);
    await this.mergeTranslations((lang: string) => lang);

    // Restore session before routing begins
    await this._sessionService.restore();
  }

  private async mergeTranslations(transformLocation: (lang: string) => string): Promise<void> {
    await Promise.all(this._translocoService.getAvailableLangs().map(async (lang) => {
      lang = typeof lang === 'string' ? lang : lang.id;
      const location = transformLocation(lang);
      // A translation file may be missing for a given language (e.g. a language
      // the app supports but a library scope does not ship). Skip it instead of
      // failing app initialization for every language.
      const translation = await lastValueFrom(
        this._translocoService.load(location).pipe(
          catchError((error) => {
            console.warn(`[i18n] Skipping missing translation "${location}"`, error);
            return of({});
          }),
        ),
      );
      this._translocoService.setTranslation(translation, lang, { merge: true });
    }));
  }
}
